import { useRef } from "react";
function useId(prefix) {
    if (void 0 === globalThis.useIdValue) globalThis.useIdValue = 0;
    const id = useRef(void 0);
    if (void 0 === id.current) id.current = `${prefix}-${globalThis.useIdValue++}`;
    return id.current;
}
export { useId };

//# sourceMappingURL=component-ids.js.map